import structureType from 'common/constants/structureTypes'
import ServerPageInterface from 'server/types/ServerPageInterface'
import { migrateCommand } from '../utils/migrateCommand'
import { migrateBlogPostBody } from './migrate-blog-post-body'

export default function (page: ServerPageInterface) {
  return migrateCommand({
    page,
    structureType: structureType.BLOG_POST_BODY,
    migrateFunction: migrateBlogPostBody,
  })
}
